// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "027ac44d3545df7f6e7f2851bd8a9873bb8bce73/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};